import React, { useId } from 'react';
import styled from 'styled-components';

import { CircleIcon } from '@ui/icons/CircleIcon.tsx';
import Tooltip from '@ui/tooltip';
import VisuallyHidden from '@ui/visuallyHidden';

const TightTooltip = styled(Tooltip)`
  width: fit-content;
`;

const AddStopButton = styled.button`
  display: flex;
  width: fit-content;
  font-weight: 500;
  font-size: 16px;
  background: none;
  border: none;
  opacity: ${props => (props['aria-disabled'] ? '0.5' : '1')};
  cursor: ${props => (props['aria-disabled'] ? 'not-allowed' : 'pointer')};
  & svg {
    cursor: ${props => (props['aria-disabled'] ? 'not-allowed' : 'pointer')};
  }
`;

const StyledAddStopText = styled.div`
  color: var(--color-widgetText);
  margin: auto;
  padding-inline-start: 10px;
`;

// Note: We only show the tooltip when the button is disabled - so tooltipText is always
// related to why it is disabled.
const AddWaypointButton = ({ ref, disabled, text, handleAddStop, theme, T }) => {
  const descriptionId = useId();

  return (
    <TightTooltip text={text} arrowPosition={'right'} isVisible={disabled}>
      <AddStopButton
        ref={ref}
        tabIndex="0"
        data-testid="AddStop"
        onClick={(...args) => !disabled && handleAddStop(...args)}
        aria-disabled={disabled}
        aria-label={T('getDirectionsFromTo:Add stop')}
        aria-describedby={disabled && text ? descriptionId : undefined}
      >
        <CircleIcon
          name="add"
          cdn
          backgroundColor={theme?.colors?.primaryButton || 'blue'}
          size={20}
          fillColor={theme?.colors?.primaryButtonText || 'white'}
        />
        <StyledAddStopText disabled={disabled} data-testid="AddStopText">
          {T('getDirectionsFromTo:Add stop')}
        </StyledAddStopText>
        {disabled && text && <VisuallyHidden id={descriptionId}>{text}</VisuallyHidden>}
      </AddStopButton>
    </TightTooltip>
  );
};

export default AddWaypointButton;
